import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { TextInputControl } from '@/core/components';

export interface IdentifiersControlProps {
  isSubmitting: boolean;

  showWosFields: boolean;
  showScopusFields: boolean;
}

export function IdentifiersControl(props: IdentifiersControlProps) {
  const { isSubmitting, showScopusFields, showWosFields } = props;
  const { t } = useTranslation();

  return (
    <>
      <TextInputControl
        name="identifiers.doi"
        leftSectionWidth="160px"
        leftSection={<Text>https://dx.doi.org/</Text>}
        label={t('publications.form.fields.identifiers.doi')}
        isSubmitting={isSubmitting}
      />
      {showWosFields && (
        <Group>
          <TextInputControl
            name="identifiers.wosId"
            leftSectionWidth="60px"
            leftSection={<Text fw="500">WOS:</Text>}
            label={t('publications.form.fields.identifiers.wosId')}
            isSubmitting={isSubmitting}
          />
          <TextInputControl
            name="identifiers.wosLink"
            label={t('publications.form.fields.identifiers.wosLink')}
            isSubmitting={isSubmitting}
          />
        </Group>
      )}
      {showScopusFields && (
        <Group>
          <TextInputControl
            name="identifiers.scopusId"
            leftSectionWidth="80px"
            leftSection={<Text fw="500">SCOPUS:</Text>}
            label={t('publications.form.fields.identifiers.scopusId')}
            isSubmitting={isSubmitting}
          />
          <TextInputControl
            name="identifiers.scopusLink"
            label={t('publications.form.fields.identifiers.scopusLink')}
            isSubmitting={isSubmitting}
          />
        </Group>
      )}
    </>
  );
}
